module.exports = __webpack_public_path__ + "static/media/logo.7bb5c090.jpg";